import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 32 31"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M30.8 15.4c0 8.1-6.7 14.6-15 14.6S.8 23.5.8 15.4 7.5.8 15.8.8s15 6.5 15 14.6",
  style: {"fill":"#de1d2a"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.8 1.6C8 1.6 1.7 7.8 1.7 15.4S8 29.2 15.8 29.2 30 23 30 15.4 23.6 1.6 15.8 1.6M0 15.4C0 6.9 7.1 0 15.8 0s15.8 6.9 15.8 15.4-7.1 15.4-15.8 15.4S0 23.9 0 15.4",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#de1d2a"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m15.5 17.4-.4-6.1-.1-2.7h3l-.1 2.7-.4 6.1zm1 4.8c-.5 0-.9-.2-1.3-.5-.3-.4-.5-.8-.5-1.3s.2-1 .5-1.3c.3-.4.8-.5 1.3-.5s.9.2 1.3.5c.3.3.5.8.5 1.3s-.2 1-.5 1.3c-.4.4-.8.5-1.3.5",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }